import {useFeaturesState} from '../../../../Organisms/Features'
import {Order} from '../../../../Pages/Order/Order.types'
import {isOrderConfirmable} from '../utils/orderManagementUtils'

export type ManageOrderButtonVariant = 'manage' | 'manageAndConfirm'

export interface ManageOrderButtonVisibility {
  isVisible: boolean
  variant: ManageOrderButtonVariant
  isLoading: boolean
}

/**
 * @param order - The order to check visibility for
 * @returns object with isVisible boolean, variant type, and loading state
 */
export const useManageOrderButtonVisibility = (order?: Order): ManageOrderButtonVisibility => {
  const {getFeature} = useFeaturesState()
  const isOrderManagementEnabled = getFeature('OrderManagementRMCHub')

  const isOrderChangeable = order?.orderManagement?.isChangeable ?? false

  // Basic visibility check (before fetching change request status)
  const shouldCheckChangeRequestStatus = !!order && isOrderChangeable && isOrderManagementEnabled

  // TODO: Enable once backend support is available
  // Wait for BE story that will extend to public api in v2 and provide latest order change request instead of getting all requests
  /*
  const {data: changeRequestStatus, isLoading} = useGetOrderChangeRequestStatus(
    order?.orderId ?? '',
    shouldCheckChangeRequestStatus
  )
  */
  // const hasPendingChangeRequest = isOrderChangeRequestPending(changeRequestStatus?.status)
  const hasPendingChangeRequest = false // Temporarily disabled until backend support is available
  // const hasPendingApproval = isOrderChangeRequestPendingApproval(changeRequestStatus?.status)
  const hasPendingApproval = false // Temporarily disabled until backend support is available

  const isVisible =
    shouldCheckChangeRequestStatus && !hasPendingChangeRequest && !hasPendingApproval

  const isConfirmable = !!order && isOrderConfirmable(order)
  const variant: ManageOrderButtonVariant = isConfirmable ? 'manageAndConfirm' : 'manage'

  return {isVisible, variant, isLoading: false /* shouldCheckChangeRequestStatus  && isLoading */}
}
